<template>
    <div class="attitude-ranking">
        <div class="attitude-ranking_title">
            <span>态度考核</span>
        </div>

        <div class="attitude-ranking_filter">
            <el-cascader
                v-model="courseValue"
                :options="courseOptions"
                :props="cascProp"
                @change="handleChapterChange"
                :show-all-levels="false"
            ></el-cascader>

            <el-button type="primary" @click="handleBack">返回</el-button>
        </div>

        <div class="attitude-ranking_box">
            <div class="box-top">
                <template v-if="attitudeData.list.length > 0">
                    <div class="top-title">态度考核分数排名</div>
                    <div class="top-chart" ref="trainingChartRef"></div>
                </template>

                <div class="box-empty" v-else>
                    <img src="@/assets/images/discussion-empty.png" alt="" />
                    <span>暂无数据</span>
                </div>
            </div>

            <div class="box-bottom">
                <div class="score-item" v-for="scoreItem in scoreOptions" :key="scoreItem.key">
                    <div class="score-item_top">
                        <div class="top-label">{{ scoreItem.label }}</div>
                    </div>

                    <div class="score-item_bottom">
                        <el-progress
                            type="circle"
                            :percentage="attitudeData[scoreItem.key]"
                            :width="160"
                            :stroke-width="12"
                            stroke-linecap="butt"
                            :color="scoreItem.color"
                            :show-text="false"
                        ></el-progress>

                        <div class="progress-text">{{ attitudeData[scoreItem.key] }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AttitudeRanking",
    data() {
        return {
            scoreOptions: [
                { key: "max_score", label: "最高分", color: "#165DFF" },
                { key: "avg_score", label: "平均分", color: "#4FD1C5" },
                { key: "min_score", label: "最低分", color: "#FEAE65" },
            ],
            attitudeData: {
                list: [],
                max_score: 0,
                avg_score: 0,
                min_score: 0,
            },
            project_list: [],
            project_id: undefined,
            chartMap: new Map(),
            courseOptions: [],
            courseValue: [],
            cascProp: { label: "name", children: "children", value: "index" },
            course_id: undefined,
        };
    },
    mounted() {
        // this.getAttitudeData();
        this.getCourseList();

        window.addEventListener("resize", this.resizeChart);
    },
    methods: {
        // 获取课程列表
        getCourseList() {
            this.course_id = Number(this.$route.query.course_id);

            // /admin/cefinoorsu;
            const params = {
                id: Number(this.$route.query.course_id),
            };

            this.$shttp.axiosGetBy(this.$api.courseContent, params, (res) => {
                if (res.code === 200) {
                    const courseContent = res.data.course_content;
                    this.formatterCourseList(courseContent);

                    this.courseOptions = courseContent;
                    this.courseValue = [0, 0];

                    this.getAttitudeData();
                }
            });
        },

        formatterCourseList(courseList) {
            for (let i = 0; i < courseList.length; i++) {
                const courseItem = courseList[i];

                if (!!courseItem.id) return false;

                courseItem.index = i;

                if (courseItem.children && courseItem.children.length > 0) {
                    if (!this.formatterCourseList(courseItem.children)) {
                        delete courseItem.children;
                    }
                }
            }

            return true;
        },

        getAttitudeData() {
            if (this.courseValue.length < 2) return;

            const params = {
                c_id: Number(this.$route.query.class_id),
                course_id: Number(this.$route.query.course_id),
                course_chapter: this.courseValue[0],
                course_node: this.courseValue[1],
            };

            this.$shttp.axiosGetBy(this.$api.evaluation_attitude_list, params, (res) => {
                if (res.code === 200) {
                    this.attitudeData = res.data;
                    this.attitudeData.list = this.attitudeData.list.sort((a, b) => {
                        return b.score - a.score;
                    });

                    this.$nextTick(() => {
                        this.setAttitudeChart();
                    });
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        handleChapterChange(val) {
            this.courseValue = val;
            this.getAttitudeData();
        },

        resizeChart() {
            for (const [_, value] of this.chartMap) {
                value.resize();
            }
        },

        setAttitudeChart() {
            if (!this.$refs.trainingChartRef) return;
            const chart = this.$echarts.init(this.$refs.trainingChartRef);
            const xData = this.attitudeData.list.map((item) => {
                const data = { s_id: item.s_id, s_name: item.s_name };
                return JSON.stringify(data);
            });
            const yData = this.attitudeData.list.map((item) => item.score);

            const options = {
                grid: {
                    left: "3%",
                    right: "1%",
                    bottom: "30%",
                    top: "5%",
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                        shadowStyle: {
                            opacity: 0,
                        },
                    },
                    borderWidth: 0,
                    backgroundColor: "#ffffff",
                    extraCssText:
                        "box-shadow: 0px 8px 10px -5px rgba(0,0,0,0.08), 0px 16px 24px 2px rgba(0,0,0,0.04), 0px 6px 30px 5px rgba(0,0,0,0.05);",
                    formatter: function(params) {
                        const _params = params[0];
                        const xData = JSON.parse(_params.name);
                        const yData = _params.data;

                        return `
                            <div class="bar-tooltip">
                                <div class="tooltip-item">
                                    <div class="tooltip-item_title">${xData.s_name}</div>
                                    <div class="tooltip-item_score">
                                        <span>分数：</span>
                                        <span>${yData}</span>
                                    </div>
                                </div>
                            </div>
                        `;
                    },
                },
                xAxis: {
                    type: "category",
                    data: xData,
                    axisTick: {
                        show: false,
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: "dashed",
                        },
                    },
                    axisLabel: {
                        formatter: function(params) {
                            const data = JSON.parse(params);
                            return data.s_name;
                        },
                    },
                },
                yAxis: {
                    type: "value",
                    max: 100,
                    axisLine: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                    splitLine: {
                        lineStyle: {
                            type: "dashed",
                        },
                    },
                },
                series: [
                    {
                        data: yData,
                        type: "bar",
                        barMaxWidth: 24,
                        itemStyle: {
                            color: "#165DFF",
                        },
                    },
                ],
            };

            chart.setOption(options);

            // 监听点击事件
            // chart.on("click", (params) => {
            //     if (params.componentType === "series") {
            //         var data = JSON.parse(params.name);

            //         this.$router.push({
            //             path: "/qualityCourse/teacher/dataEvaluationIndex/attitudeDetail",
            //             query: {
            //                 course_id: this.$route.query.course_id,
            //                 zhangIndex: this.$route.query.zhangIndex,
            //                 jieIndex: this.$route.query.jieIndex,
            //                 s_id: data.s_id,
            //             },
            //         });
            //     }
            // });

            chart.getZr().on("click", (params) => {
                let containPixel = [params.offsetX, params.offsetY];
                if (chart.containPixel("grid", containPixel)) {
                    const xIndex = chart.convertFromPixel({ seriesIndex: 0 }, containPixel)[0]; // 获取是第几个数据
                    const opData = chart.getOption();

                    const data = JSON.parse(opData.xAxis[0].data[xIndex]);

                    this.$router.push({
                        path: "/qualityCourse/teacher/dataEvaluationIndex/attitudeDetail",
                        query: {
                            course_id: this.$route.query.course_id,
                            zhangIndex: this.courseValue[0],
                            jieIndex: this.courseValue[1],
                            s_id: data.s_id,
                            class_id: this.$route.query.class_id,
                        },
                    });
                }
            });

            if (!this.chartMap.has("trainingChart")) {
                this.chartMap.set("trainingChart", chart);
            }
        },

        handleBack() {
            this.course_id = undefined;
            this.$router.back();
        },
    },

    activated() {
        if (!this.course_id || Number(this.$route.query.course_id) !== this.course_id) {
            this.getCourseList();
        }
    },

    destroyed() {
        window.removeEventListener("resize", this.resizeChart);
    },
};
</script>

<style lang="scss" scoped>
::v-deep .bar-tooltip {
    padding: 14px;
    color: #333333;

    .tooltip-item {
        &:not(.tooltip-item:last-of-type) {
            margin-bottom: 10px;
        }

        &_title {
            font-family: PingFang-SC, PingFang-SC;
            font-weight: 400;
            font-size: 14px;
            line-height: 22px;
        }

        &_score {
            min-width: 100px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            // gap: 70px;
            font-family: PingFang-SC, PingFang-SC;
            font-weight: 400;
            font-size: 14px;
            line-height: 22px;
        }
    }
}

.attitude-ranking {
    width: 100%;
    height: 100%;
    padding: 20px;
    box-sizing: border-box;
    background-color: #efefef;

    &_title {
        font-family: PingFang-SC, PingFang-SC;
        height: 24px;
        font-weight: 800;
        font-size: 24px;
        color: #333333;
        line-height: 24px;
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .el-button {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 88px;
            height: 36px;
        }
    }

    &_filter {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20px;

        .el-button {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 88px;
            height: 36px;
        }

        ::v-deep .el-input__inner {
            background-color: #ffffff !important;
        }
    }

    &_box {
        height: calc(100% - 100px);
        // background-color: #333333;

        .box-top {
            height: calc(100% - 306px);
            background-color: #ffffff;
            border-radius: 8px;
            box-sizing: border-box;
            padding: 24px;

            .top-title {
                height: 24px;
                font-family: PingFang-SC, PingFang-SC;
                font-weight: 500;
                font-size: 16px;
                color: #26292e;
                line-height: 24px;
                margin-bottom: 50px;
            }

            .top-chart {
                height: calc(100% - 74px);
                // background-color: lightgray;
            }

            .box-empty {
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                gap: 20px;

                span {
                    height: 20px;
                    font-family: PingFang-SC, PingFang-SC;
                    font-weight: 400;
                    font-size: 14px;
                    color: #999999;
                    line-height: 16px;
                }
            }
        }

        .box-bottom {
            height: 286px;
            margin-top: 20px;
            display: flex;
            gap: 16px;

            .score-item {
                width: calc((100% - 32px) / 3);
                height: 100%;
                background-color: #ffffff;
                border-radius: 8px;
                box-sizing: border-box;
                padding: 24px;
                overflow: hidden;

                &_top {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    .top-label {
                        font-family: PingFang-SC, PingFang-SC;
                        font-weight: 500;
                        font-size: 16px;
                        color: #000000;
                        flex-shrink: 0;
                    }

                    .top-enter {
                        display: flex;
                        align-items: center;
                        gap: 4px;
                        cursor: pointer;

                        img {
                            width: 16px;
                            height: 16px;
                            object-fit: cover;
                        }

                        span {
                            font-family: PingFang-SC, PingFang-SC;
                            font-weight: 400;
                            font-size: 12px;
                            color: #006eff;
                            flex-shrink: 0;
                        }
                    }
                }

                &_bottom {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-top: 40px;
                    position: relative;

                    .progress-text {
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -50%);
                        font-family: PingFang-SC, PingFang-SC;
                        font-weight: 600;
                        font-size: 36px;
                        color: #000000;
                    }
                }
            }
        }
    }
}
</style>
